import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.js";
import "./i18n/i18n.js";
import { initTheme } from "./store/themeStore.js";
import "./styles/global.css";

/* Aplicar tema guardado antes del primer render (evita flash) */
initTheme();

const el = document.getElementById("root");
if (!el) throw new Error("Missing #root");

createRoot(el).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
